var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"jira-issue-field-component-picker"},[(_vm.value)?_c('span',[_vm._v(" "+_vm._s(_vm.value.displayName)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }